module.exports = __webpack_public_path__ + "static/media/video-icon.7ad51f1b.svg";